import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'


export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectProcessState = (state) => {
    return selectOwnState(state).processState
}

export const selectMode = (state) => {
    const processState = selectProcessState(state)
    return processState.mode
}

export const selectYearWeekList = (state) => {
    return selectOwnState(state).yearWeekList
}

export const selectTransitionList = (state) => {
    return selectOwnState(state).transitionList
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/transition/selector.js